module.exports = __webpack_public_path__ + "static/media/advertisers_m_3.b2cba241.png";